import { globalPerf } from './perf';

const TCC_MEASURE = 'tcc_measure_';

/**
 * Holds all the custom measure names created
 * @type {Array<String>}
 */
let measureNames = [];

/**
 * Returns a measure by the given name
 * @param {String} name
 * @return {Object} measure
 */
export function getMeasure(name) {
  if (!globalPerf.getEntriesByName) {
    return null;
  }

  return globalPerf.getEntriesByName(TCC_MEASURE + name)[0];
}

/**
 * Creates a Measure with the given from and to marks
 * @param {String} name
 * @param {String} fromMark
 * @param {String} toMark
 * @return {Object} measure
 */
export function createMeasure(name, fromMark, toMark) {
  if (!globalPerf.measure) {
    return null;
  }

  const tccName = TCC_MEASURE + name;

  // Do not allow overriding
  if (measureNames.includes(tccName)) {
    return false;
  }

  globalPerf.measure(tccName, fromMark, toMark);
  measureNames = measureNames.concat(name);

  return getMeasure(name);
}

/**
 * Returns all created measures.
 * @return {Array<Object>} Metrics list
 */
export function getAllMeasures() {
  return measureNames.map(getMeasure);
}

/**
 * Needed for testing purposes. Use under your own consideration.
 * @return {void}
 */
export function resetMeasures() {
  measureNames = [];
}
